import { loadStripe } from '@stripe/stripe-js';
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin(async (nuxtApp) => {
  const stripe = await loadStripe(nuxtApp.$config.public.stripe.publishableKey);

  nuxtApp.provide('stripe', stripe);
});
